import { ArrowDownOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Collapse,
  Form,
  Checkbox,
  Input,
  message,
  Row,
  Radio,
} from 'antd';
import { useState, useEffect, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchVendorById, editVendor } from '../../slices/vendor';

const { Panel } = Collapse;

function EditVendor() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const previousValues = useRef({
    indian: null,
    overseas: null
  });

  useEffect(() => {
    const fetchVendor = async () => {
      try {
        dispatch(fetchVendorById(id))
          .unwrap()
          .then(response => {
            if (response.results.data.length > 0) {

              const vendorData = response.results.data[0];
              if (Object.keys(vendorData).length > 0) {
                form.setFieldsValue({
                  gst_no: vendorData ? vendorData.gst_no : '',
                  udyam_aadhaar_no: vendorData ? vendorData.udyam_aadhaar_no : '',
                  website: vendorData ? vendorData.website : '',
                  fax_number: vendorData ? vendorData.fax_number : '',
                  business_type: vendorData ? vendorData.business_type : '',
                  import_export_code: vendorData ? vendorData.import_export_code : '',
                  beneficiary_agent_code: vendorData ? vendorData.beneficiary_agent_code : '',
                  vendor_registered_name: vendorData
                    ? vendorData.vendor_registered_name
                    : '',
                  vendor_trade_name: vendorData
                    ? vendorData.vendor_trade_name
                    : '',
                  vendor_code_as_per_company_erp: vendorData
                    ? vendorData.vendor_code_as_per_company_erp
                    : '',
                  person_name: vendorData ? vendorData.person_name : '',
                  designation: vendorData ? vendorData.designation : '',
                  email: vendorData ? vendorData.email : '',
                  phone: vendorData ? vendorData.phone : '',
                  registered_business_address_building: vendorData
                    ? vendorData.registered_business_address_building
                    : '',
                  registered_business_address_area: vendorData
                    ? vendorData.registered_business_address_area
                    : '',
                  registered_business_address_landmark: vendorData
                    ? vendorData.registered_business_address_landmark
                    : '',
                  registered_business_address_pincode: vendorData
                    ? vendorData.registered_business_address_pincode
                    : '',
                  registered_business_address_state: vendorData
                    ? vendorData.registered_business_address_state
                    : '',
                  registered_business_address_city: vendorData
                    ? vendorData.registered_business_address_city
                    : '',
                  registered_business_address_country: vendorData
                    ? vendorData.registered_business_address_country
                    : '',
                  trading_address_building: vendorData
                    ? vendorData.trading_address_building
                    : '',
                  trading_address_area: vendorData
                    ? vendorData.trading_address_area
                    : '',
                  trading_address_landmark: vendorData
                    ? vendorData.trading_address_landmark
                    : '',
                  trading_address_pincode: vendorData
                    ? vendorData.trading_address_pincode
                    : '',
                  trading_address_state: vendorData
                    ? vendorData.trading_address_state
                    : '',
                  trading_address_city: vendorData
                    ? vendorData.trading_address_city
                    : '',
                  trading_address_country: vendorData
                    ? vendorData.trading_address_country
                    : '',
                  keypersons: vendorData.keypersons || [
                    {
                      person_name: '',
                      designation: '',
                      contact_number: '',
                      email: '',
                    },
                  ],
                  bankdetails: vendorData.bankdetails || [
                    {
                      bank_name: '',
                      bank_account_number: '',
                      bank_ifsc_code: '',
                      branch_address: '',
                      bank_ad_code: '',
                      beneficiary_swift_code: '',
                    },
                  ],
                });
                if (vendorData.business_type) {
                  setSelectedOption(vendorData.business_type);
                }
              }
            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    }
    fetchVendor();
  }, [id])
  const getEmptyIndianTemplate = () => ({
    gst_no: '',
    import_export_code: '',
    fax_number: '',
    beneficiary_agent_code: '',
    udyam_aadhaar_no: '',
    vendor_registered_name: '',
    designation: '',
    vendor_trade_name: '',
    website: '',
    person_name: '',
    email: '',
    phone: '',
    vendor_code_as_per_company_erp: null,
    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: '',
    registered_business_address_pincode: '',
    registered_business_address_state: '',
    registered_business_address_city: '',
    registered_business_address_country: '',
    trading_address_building: '',
    trading_address_area: '',
    trading_address_landmark: '',
    trading_address_pincode: '',
    trading_address_state: '',
    trading_address_city: '',
    trading_address_country: '',
    keypersons: [
      { person_name: '', designation: '', contact_number: '', email: '' }, // Example initial contact person
    ],
    bankdetails: [
      {
        bank_name: '',
        bank_account_number: '',
        bank_ifsc_code: '',
        branch_address: '',
        bank_ad_code: '',
        beneficiary_swift_code: '',
      },
    ],
  });

  const getEmptyOverseasTemplate = () => ({
    gst_no: '',
    import_export_code: '',
    fax_number: '',
    beneficiary_agent_code: '',
    udyam_aadhaar_no: '',
    vendor_registered_name: '',
    designation: '',
    vendor_trade_name: '',
    website: '',
    person_name: '',
    email: '',
    phone: '',
    vendor_code_as_per_company_erp: null,
    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: '',
    registered_business_address_pincode: '',
    registered_business_address_state: '',
    registered_business_address_city: '',
    registered_business_address_country: '',
    trading_address_building: '',
    trading_address_area: '',
    trading_address_landmark: '',
    trading_address_pincode: '',
    trading_address_state: '',
    trading_address_city: '',
    trading_address_country: '',
    keypersons: [
      { person_name: '', designation: '', contact_number: '', email: '' }, // Example initial contact person
    ],
    bankdetails: [
      {
        bank_name: '',
        bank_account_number: '',
        bank_ifsc_code: '',
        branch_address: '',
        bank_ad_code: '',
        beneficiary_swift_code: '',
      },
    ],
  });
  const handleCopyBusinessAddressChange = e => {
    if (e.target.checked) {
      form.setFieldsValue({
        trading_address_building: form.getFieldValue(
          'registered_business_address_building',
        ),
        trading_address_area: form.getFieldValue(
          'registered_business_address_area',
        ),
        trading_address_landmark: form.getFieldValue(
          'registered_business_address_landmark',
        ),
        trading_address_pincode: form.getFieldValue(
          'registered_business_address_pincode',
        ),
        trading_address_city: form.getFieldValue(
          'registered_business_address_city',
        ),
        trading_address_state: form.getFieldValue(
          'registered_business_address_state',
        ),
        trading_address_country: form.getFieldValue(
          'registered_business_address_country',
        ),
      });
    } else {
      form.setFieldsValue({
        trading_address_building: '',
        trading_address_area: '',
        trading_address_landmark: '',
        trading_address_pincode: '',
        trading_address_city: '',
        trading_address_state: '',
        trading_address_country: '',
      });
    }
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedData = {
      ...values,
      business_type: selectedOption, // Use the selectedOption state for business_type
    };

    dispatch(editVendor({ id: id, values: formattedData }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Vendor Updated Successfully!');
          navigate('/vendor-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  return (
    <>
      <div className='sticyaction'>
        <div className="pagenamerow">
          <h2>Edit Vendor</h2>
          <div className="bredcrumbwrp">
            <Link to="/vendor-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/vendor-list">Vendors</Link> },
                { title: 'Edit Vendor' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
        >
          <Form.Item >
            <Radio.Group
              value={selectedOption}
              name="business_type"
              onChange={(e) => {
                const newValue = e.target.value;
                const previousValue = selectedOption;
                setSelectedOption(newValue);
                form.setFieldsValue({ business_type: newValue });
                if (newValue !== previousValue) {
                  setSelectedOption(newValue);
                  form.setFieldsValue({ business_type: newValue });
                  if (previousValue) {
                    previousValues.current[previousValue.toLowerCase()] = form.getFieldsValue();
                  }
                  if (previousValues.current[newValue.toLowerCase()]) {
                    form.setFieldsValue(previousValues.current[newValue.toLowerCase()]);
                  } else {
                    form.setFieldsValue({
                      business_type: newValue,
                      ...(newValue === "INDIAN" ? getEmptyIndianTemplate() : getEmptyOverseasTemplate())
                    });
                  }
                }
              }}
            >
              <Radio value="INDIAN">INDIAN</Radio>
              <Radio value="OVERSEAS">OVERSEAS</Radio>
            </Radio.Group>
          </Form.Item>
          <Collapse defaultActiveKey={['8']} className="mb-4">
            <Panel header="Tax Information" key="8" forceRender={true} >
              <Row gutter={16}>
                {selectedOption === "INDIAN" && (
                  <>
                    <Col xs={24} sm={12} md={4}>
                      <Form.Item
                        label="GSTIN Number"
                        name="gst_no"
                        rules={[
                          { required: true, message: 'Please enter GSTIN number' },
                          {
                            pattern:
                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                            message: 'Please enter a valid GSTIN number',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Gstin Number" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={7} xl={5}>
                      <Form.Item
                        label="Udyam Number"
                        name="udyam_aadhaar_no"
                        rules={[
                          {
                            pattern: /^[A-Z0-9-]+$/,
                            message: 'Only uppercase letters (A-Z), numbers (0-9), and hyphens (-) are allowed.',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Udyam Aadhar Number" onChange={e => {
                          const value = e.target.value;
                          const formattedValue = value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());
                          form.setFieldsValue({ udyam_aadhaar_no: formattedValue });
                        }} />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {selectedOption === "OVERSEAS" && (
                  <>
                    <Col xs={24} lg={4}>
                      <Form.Item
                        label="Import Export Code"
                        name="import_export_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid import export code',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter import export code"
                          maxLength={12}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={4}>
                      <Form.Item
                        label="Baneficery Agent Code"
                        name="beneficiary_agent_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid import export code',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter beneficery agent code"
                          maxLength={16}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={[]} className="mb-4">
            <Panel header="Business Information" key="1">
              <Row gutter={16}>
                <Col xs={24} sm={12} md={5}>
                  <Form.Item
                    label="Vendor Registered Name"
                    name="vendor_registered_name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter vendor registered name ',
                      },
                      {
                        pattern: /^[a-zA-Z\s]+$/,
                        message: 'Please enter only letters and spaces',
                      },
                    ]}
                  >
                    <Input
                      maxLength={50}
                      placeholder="Enter Vendor Registered Name"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          vendor_registered_name: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Vendor Trade Name"
                    name="vendor_trade_name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid vendor trade name ',
                      },
                      {
                        pattern: /^[a-zA-Z\s]+$/,
                        message: 'Please enter only letters and spaces',
                      },
                    ]}
                  >
                    <Input
                      maxLength={50}
                      placeholder="Enter Vendor Trade Name"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          vendor_trade_name: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6} md={6} xl={6}>
                  <Form.Item
                    label="Vender Code as per Company ERP System"
                    name="vendor_code_as_per_company_erp"
                    rules={[
                      {
                        required: true,
                        message:
                          'Please enter valid vender code as per company ero system ',
                      },
                      {
                        pattern: /^[a-zA-Z0-9\s]+$/,
                        message: 'Please enter only letters and spaces',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Vender Code as per Company ERP System"
                      maxLength={25} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Fax Number"
                    name="fax_number"
                  >
                    <Input
                      placeholder="Enter Fax Number"
                      maxLength={25}
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          fax_number: formattedValue,
                        }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Website"
                    name="website"
                  >
                    <Input placeholder="Enter Website"
                      maxLength={40}
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          website: formattedValue,
                        }); // Update Form state
                      }} />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <Collapse defaultActiveKey={[]} className="mb-4">
            <Panel header="Contact Information" key="2" forceRender={true}>
              <div>
                <Row gutter={16}>
                  <Col flex="auto">
                    <Row gutter={16}>
                      <Col xs={24} sm={12} md={4}>
                        <Form.Item
                          name="person_name"
                          label="Person Name"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter valid name',
                            },
                            {
                              pattern: /^[a-zA-Z\s]+$/,
                              message: 'Please enter valid name',
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter Name"
                            maxLength={50}
                            onChange={e => {
                              const value = e.target.value;
                              const formattedValue = value
                                .toLowerCase()
                                .replace(/\b\w/g, char => char.toUpperCase());
                              form.setFieldsValue({
                                person_name: formattedValue,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={4}>
                        <Form.Item
                          name="designation"
                          label="Designation"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter valid designation',
                            },
                            {
                              pattern: /^[a-zA-Z\s]+$/,
                              message: 'Please enter valid designation',
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter Designation"
                            maxLength={20}
                            onChange={e => {
                              const value = e.target.value;
                              const formattedValue = value
                                .toLowerCase()
                                .replace(/\b\w/g, char => char.toUpperCase());
                              form.setFieldsValue({
                                designation: formattedValue,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={4}>
                        <Form.Item
                          label="Mobile Number"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: 'Please input your phone number!',
                            },
                          ]}
                        >
                          <PhoneInput
                            country={'in'}
                            enableSearch={true}
                            placeholder="Enter phone number"
                            onChange={value => (value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={12} sm={12} md={8} xl={6}>
                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[
                            {
                              type: 'email',
                              message: 'Please enter a valid email address',
                              required: true,
                            },
                          ]}
                        >
                          <Input placeholder="Enter Email" />
                        </Form.Item>
                      </Col>
                    </Row>

                  </Col>
                </Row>
              </div>
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={[]} className="mb-4">
            <Panel header="Address Information" key="12" forceRender={true}>
              <div>
                <Row gutter={16}>
                  <Col flex="auto">
                    <Row gutter={16}>
                      <Col xs={24} sm={12}>
                        <h3 className="adrstitle">
                          Registered Business Address
                        </h3>
                        <Row gutter={16}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Shop No, Building, Apartment"
                              name="registered_business_address_building"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Please enter valid shop no, building, apartment',
                                },
                                {
                                  pattern: /^[A-Za-z0-9\s,.-]*$/,
                                  message: 'Only alphabets, numbers, spaces, commas, periods, and hyphens are allowed.'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Enter shop no, building, apartment"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char => char.toUpperCase());
                                  form.setFieldsValue({ registered_business_address_building: formattedValue });
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Area, Street"
                              name="registered_business_address_area"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid area, street',
                                },
                                {
                                  pattern: /^[A-Za-z0-9\s,.-]*$/,
                                  message: 'Only alphabets, numbers, spaces, commas, periods, and hyphens are allowed.'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Enter area, street"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char => char.toUpperCase());
                                  form.setFieldsValue({ registered_business_address_area: formattedValue });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Landmark"
                              name="registered_business_address_landmark"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid landmark',
                                },
                                {
                                  pattern: /^[A-Za-z0-9\s,.-]*$/,
                                  message: 'Only alphabets, numbers, spaces, commas, periods, and hyphens are allowed.'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Enter landmark"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char => char.toUpperCase());
                                  form.setFieldsValue({ drawing_no: formattedValue });
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Pin Code"
                              name="registered_business_address_pincode"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter a valid pincode',
                                },
                                {
                                  pattern: /^\d{6}$/,
                                  message:
                                    'Please enter a valid 6-digit pin code',
                                },
                              ]}
                            >
                              <Input placeholder="Enter pincode"
                                maxLength={6}
                                onChange={e => {
                                  const value = e.target.value.replace(
                                    /\D/g,
                                    '',
                                  ); // Remove non-numeric characters
                                  e.target.value = value; // Set only numeric values
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="City"
                              name="registered_business_address_city"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid city',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid city name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter City"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toUpperCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    registered_business_address_city:
                                      formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="State"
                              name="registered_business_address_state"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid state',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid state name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter State"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toUpperCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    registered_business_address_state:
                                      formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Country"
                              name="registered_business_address_country"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid country',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid country name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter Country"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toUpperCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    registered_business_address_country:
                                      formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} sm={12}>
                        <h3 className="adrstitle">
                          Trading Address
                          <div style={{ display: 'inline-flex' }}>
                            <Checkbox
                              className="copytxt"
                              onChange={handleCopyBusinessAddressChange}
                            >
                              ( <ArrowDownOutlined /> Copy registered business
                              address )
                            </Checkbox>
                          </div>
                        </h3>
                        <Row gutter={16}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Shop No, Building, Apartment"
                              name="trading_address_building"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Please enter valid shop no, building, apartment',
                                },
                                {
                                  pattern: /^[A-Za-z0-9\s,.-]*$/,
                                  message: 'Only alphabets, numbers, spaces, commas, periods, and hyphens are allowed.'
                                }
                              ]}
                            >
                              <Input placeholder="Enter shop no, building, apartment"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char => char.toUpperCase());
                                  form.setFieldsValue({ trading_address_building: formattedValue });
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Area, Street"
                              name="trading_address_area"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid area, street',
                                },
                              ]}
                            >
                              <Input placeholder="Enter area, street" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Landmark"
                              name="trading_address_landmark"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid landmark',
                                },
                                {
                                  pattern: /^[A-Za-z0-9\s,.-]*$/,
                                  message: 'Only alphabets, numbers, spaces, commas, periods, and hyphens are allowed.'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Enter landmark"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char => char.toUpperCase());
                                  form.setFieldsValue({ trading_address_area: formattedValue });
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Pin Code"
                              name="trading_address_pincode"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter a valid pincode',
                                },
                                {
                                  pattern: /^\d{6}$/,
                                  message:
                                    'Please enter a valid 6-digit pin code',
                                },
                              ]}
                            >
                              <Input placeholder="Enter pincode"
                                maxLength={6}
                                onChange={e => {
                                  const value = e.target.value.replace(
                                    /\D/g,
                                    '',
                                  ); // Remove non-numeric characters
                                  e.target.value = value; // Set only numeric values
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="City"
                              name="trading_address_city"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid city',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid city name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter city"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    trading_address_city: formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="State"
                              name="trading_address_state"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid state',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid state name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter state"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    trading_address_state: formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={6}>
                            <Form.Item
                              label="Country"
                              name="trading_address_country"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid country',
                                },
                                {
                                  pattern: /^[a-zA-Z\s]+$/,
                                  message: 'Please enter valid country name',
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter country"
                                onChange={e => {
                                  const value = e.target.value;
                                  const formattedValue = value
                                    .toLowerCase()
                                    .replace(/\b\w/g, char =>
                                      char.toUpperCase(),
                                    );
                                  form.setFieldsValue({
                                    trading_address_country: formattedValue,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={[]} className="mb-4">
            <Panel header="Key Person" key="3" forceRender={true}>
              <Form.List name="keypersons">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row
                        className="rowItem mx-0"
                        gutter={[24, 24]}
                        align="middle"
                        key={key}
                        wrap={false}
                      >
                        <Col flex="auto">
                          <Row gutter={16}>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'person_name']}
                                label="Person Name"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid name',
                                  },
                                  {
                                    pattern: /^[a-zA-Z\s]+$/,
                                    message: 'Please enter valid name',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Name"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      ['keypersons', name, 'person_name'],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'designation']}
                                label="Designation"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid designation',
                                  },
                                  {
                                    pattern: /^[a-zA-Z\s]+$/,
                                    message: 'Please enter valid designation',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Designation"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      ['contactPersons', name, 'designation'],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'contact_number']}
                                label="Mobile Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please input your phone number!',
                                  },
                                ]}
                              >
                                <PhoneInput
                                  country="in"
                                  enableSearch
                                  placeholder="Enter phone number"
                                  onChange={value =>
                                    form.setFieldValue(
                                      ['keypersons', name, 'contact_number'],
                                      value,
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={8} xl={6}>
                              <Form.Item
                                {...restField}
                                name={[name, 'email']}
                                label="Email"
                                rules={[
                                  {
                                    type: 'email',
                                    message:
                                      'Please enter a valid email address',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Email" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Form.Item>
                            <div style={{ textAlign: 'center', marginTop: '25px', marginLeft: '39px' }}>
                              <Button
                                type="primary"
                                onClick={() => {
                                  if (fields.length < 15) {
                                    add();
                                  } else {
                                    message.error(
                                      'You can only add up to 15 records.',
                                    );
                                  }
                                }}
                                icon={<PlusOutlined />}
                              >
                                Add Key Person
                              </Button>
                            </div>
                          </Form.Item>
                        </Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              style={{ marginTop: '14px' }}
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                            />
                          )}
                        </div>
                      </Row>
                    ))}

                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>

          <Collapse defaultActiveKey={[]} className="mb-4">
            <Panel header="Banking Details" key="4" forceRender={true}>
              <Form.List name="bankdetails">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row
                        className="rowItem mx-0"
                        gutter={[24, 24]}
                        align="middle"
                        key={key}
                        wrap={false}
                      >
                        <Col flex="auto">
                          <Row gutter={16}>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'bank_name']}
                                label="Bank Name"
                                rules={[
                                  {
                                    required: true,
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: 'Please enter valid bank name',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Bank Name"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toUpperCase()
                                      .replace((char) => char.toUpperCase());
                                    form.setFieldValue(['bankdetails', name, 'bank_name'], formattedValue);
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={5}>
                              <Form.Item
                                {...restField}
                                name={[name, 'bank_account_number']}
                                label="Bank Account Number"
                                rules={[
                                  {
                                    pattern: /^[0-9]{9,27}$/,
                                    message:
                                      'Bank account number must be between 9 and 27 digits',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Bank Account Number" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'bank_ifsc_code']}
                                label="Bank IFSC Code"
                                rules={[
                                  {
                                    required: true,
                                    pattern: /^[A-Z0-9]+$/,
                                    message:
                                      'only enter numbers and characters',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Bank IFSC Code" />
                              </Form.Item>
                            </Col>
                            <Col xs={12} sm={6} md={6} xl={5}>
                              <Form.Item
                                {...restField}
                                name={[name, 'branch_address']}
                                label="Branch Address"
                              >
                                <Input placeholder="Enter Bank Branch Address"

                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char => char.toUpperCase());
                                    form.setFieldValue(
                                      ['bankdetails', name, 'branch_address'],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} sm={6} md={6} xl={5}>
                              <Form.Item
                                {...restField}
                                name={[name, 'beneficiary_swift_code']}
                                label="BENEFICIARY SWIFT CODE"

                                rules={[
                                  {
                                    pattern: /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/,
                                    message: 'Please enter a valid SWIFT code (8 or 11 characters, alphanumeric).'
                                  }
                                ]}
                              >
                                <Input
                                  placeholder="Enter BENEFICIARY SWIFT CODE"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toUpperCase()
                                      .replace(char => char.toUpperCase());
                                    form.setFieldValue(
                                      ['bankdetails', name, 'beneficiary_swift_code'],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} sm={6} md={6} xl={5}>
                              <Form.Item
                                {...restField}
                                name={[name, 'bank_ad_code']}
                                label="Bank AD Code"

                                rules={[{
                                  pattern: /^[A-Za-z0-9\s-]{6,10}$/,
                                  message: 'Bank AD Code should be 6 to 10 characters long and can include letters, numbers, spaces, and hyphens.'
                                }]}
                              >
                                <Input
                                  placeholder="Enter Bank AD Code"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toUpperCase()
                                      .replace(char => char.toUpperCase());
                                    form.setFieldValue(
                                      ['bankdetails', name, 'bank_ad_code'],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Form.Item>
                            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                              <Button
                                type="primary"
                                onClick={() => {
                                  if (fields.length < 15) {
                                    add();
                                  } else {
                                    message.error(
                                      'You can only add up to 15 records.',
                                    );
                                  }
                                }}
                                icon={<PlusOutlined />}
                              >
                                Add Banking Detail
                              </Button>
                            </div>
                          </Form.Item>
                        </Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              style={{ marginTop: '14px' }}
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                            />
                          )}
                        </div>
                      </Row>
                    ))}

                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={btnLoading}
              icon={<PlusOutlined />}
            >
              Update Vendor
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditVendor;
